<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_resources_intro')
}

const isOnResourcesSection = computed(() => {
  return route.path.startsWith('/resources')
})

const goToResources = () => {
  router.push('/resources')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.resources.intro.welcome') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.resources.intro.mined') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.resources.intro.someMaterials') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.resources.intro.goOver') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.resources.intro.clickResourcesDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.resources.intro.clickResourcesMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnResourcesSection" @click="goToResources" class="mr-2">
        {{ t('tutorial.resources.intro.goToResources') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.resources.intro.imThere') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>